export const fontFamily = {
    raleway: "'Raleway', sans-serif"
};
